import './style.css';
import Application from './Application/Application';
const app = new Application();
